export const beeswarmSpinOffs = {
  "$schema": "https://vega.github.io/schema/vega/v5.json",
  "title": {
    "offset": 30
  },
  "padding": {"left": 5, "top": 5, "right": 80, "bottom": 5},
  "signals": [
    { "name": "cx", "update": "width / 2" },
    { "name": "cy", "update": "height / 2" },
    { "name": "atecoSectorsFilters", "value": [] },
    { "name": "minimalRadius", "value": 50 }
  ],
  "data": [
    {
      "name": "spinoffs",
      "values": null,
      "transform": [
        {
          "type": "formula",
          "expr": "year(datum.foundationDate)",
          "as": "foundationYear"
        },
        {
          "type": "formula",
          "expr": "(datum.liquidationYear !== '' && datum.liquidationYear !== 0) ? datum.liquidationYear : (datum.cessationYear !== '' && datum.cessationYear !== 0) ? datum.cessationYear : null",
          "as": "closeDownYear"
        },
        {
          "type": "formula",
          "expr": "datum.closeDownYear === null ? year(datetime()) - datum.foundationYear : datum.closeDownYear - datum.foundationYear",
          "as": "lifetime"
        },
        { "type": "filter", "expr": "datum.lifetime >= 0" },
        {
          "type": "formula",
          "expr": "datum.innovative === true ? 'Innovative' : 'Non innovative'",
          "as": "innovative"
        },
        {
          "type": "formula",
          "expr": "datum.founderCapital === ''? 0:datum.founderCapital",
          "as": "founderCapital"
        },
        {
          "type": "filter",
          "expr": "length(atecoSectorsFilters) === 0 || indexof(atecoSectorsFilters, datum.atecoName) !== -1"
        }
      ]
    },
    {
      "name": "spinoffsCapitals",
      "source": "spinoffs",
      "transform": [
        {
          "type": "filter",
          "expr": "datum.founderCapital > 0"
        },
        {
          "type": "project",
          "fields": ["founderCapital"],
          "as": ["founderCapital"]
        }
      ]
    },
    {
      "name": "averageLifetime",
      "source": "spinoffs",
      "transform": [
        {
          "type": "aggregate",
          "ops": ["average"],
          "fields": ["lifetime"],
          "as": ["lifetime"]
        }
      ]
    },
    {
      "name": "colorDomain",
      "source": "spinoffs",
      "transform": [
        {
          "type": "formula",
          "expr": "datum.active === '' || datum.active === null? 'ignoto':datum.active",
          "as": "active"
        },
        {"type": "collect", "sort": {"field": "active", "order": "descending"}}
      ]
    }
  ],
  "scales": [
    {
      "name": "color",
      "type": "ordinal",
      "domain": {
        "data": "colorDomain",
        "field": "active"
      },
      "range": ["#addd8e", "#f03b20", "gray", "gray"]
    },
    {
      "name": "xscale",
      "type": "linear",
      "domain": {
        "data": "spinoffs",
        "field": "lifetime",
        "sort": true
      },
      "range": "width"
    },
    {
      "name": "xscale_average",
      "type": "linear",
      "domain": { "data": "spinoffs", "field": "lifetime" },
      "range": "width"
    },
    {
      "name": "radius",
      "type": "pow",
      "domain": { "data": "spinoffsCapitals", "field": "founderCapital" },
      "range": [{ "signal": "minimalRadius" }, 5000],
      "zero": false
    }
  ],
  "axes": [
    {
      "orient": "bottom",
      "scale": "xscale",
      "tickWidth": {
        "signal": "datum.value % 5 === 0 ? 2 : 1"
      },
      "encode": {
        "labels": {
          "update": {
            "text": {
              "signal": null
            }
          }
        }
      }
    }
  ],
  "marks": [
    {
      "name": "nodes",
      "type": "symbol",
      "from": { "data": "spinoffs" },
      "encode": {
        "enter": {
          "fill": [
            {
              "test": "datum.active === '' || datum.active === null",
              "value": "gray"
            },
            {
              "scale": "color",
              "field": "active"
            }
          ],
          "xfocus": {
            "scale": "xscale",
            "field": "lifetime",
            "band": 0.5
          },
          "yfocus": {
            "signal": "cy"
          }
        },
        "update": {
          "size": [
            { 
              "test": "!isValid(datum.founderCapital) || datum.founderCapital === 0", 
              "signal": "minimalRadius" 
            },
            { "scale": "radius", 
              "field": "founderCapital" 
            }
          ],
          "stroke": { "value": "white" },
          "strokeWidth": { "value": 0 },
          "zindex": { "value": 0 }
        },
        "hover": {
          "stroke": { "value": "#333333" },
          "strokeWidth": { "value": 2 },
          "zindex": { "value": 1 },
          "tooltip": {}
        }
      },
      "transform": [
        {
          "type": "force",
          "static": true,
          "forces": [
            {
              "force": "collide",
              "iterations": 1,
              "radius": { "expr": "1 + sqrt(datum.size) / 2" }
            },
            {
              "force": "x",
              "x": "xfocus",
              "strength": 0.5
            },
            {
              "force": "y",
              "y": "yfocus",
              "strength": 1
            }
          ]
        }
      ]
    },
    {
      "type": "rule",
      "from": {
        "data": "averageLifetime"
      },
      "encode": {
        "update": {
          "stroke": {
            "value": "#555555"
          },
          "strokeWidth": {
            "value": 1
          },
          "strokeDash": {
            "value": [1, 3]
          },
          "x": {
            "scale": "xscale_average",
            "field": "lifetime"
          },
          "x2": {
            "scale": "xscale_average",
            "field": "lifetime"
          },
          "y": {
            "value": -25
          },
          "y2": {
            "signal": "height"
          }
        }
      }
    },
    {
      "type": "symbol",
      "from": {
        "data": "averageLifetime"
      },
      "encode": {
        "update": {
          "size": {
            "value": 25
          },
          "x": {
            "scale": "xscale_average",
            "field": "lifetime"
          },
          "y": {
            "value": -25
          },
          "fill": {
            "value": "rgb(70, 53, 52)"
          }
        }
      }
    },
    {
      "type": "text",
      "from": {
        "data": "averageLifetime"
      },
      "name": "years_average",
      "encode": {
        "update": {
          "text": {
            "signal": "format(datum.lifetime, ',.1f')"
          },
          "x": {
            "scale": "xscale_average",
            "field": "lifetime"
          },
          "dx": {
            "value": -5
          },
          "y": {
            "value": -35
          },
          "fill": {
            "value": "rgb(70, 53, 52)"
          }
        }
      }
    },
    {
      "type": "text",
      "from": {
        "data": "averageLifetime"
      },
      "encode": {
        "update": {
          "text": {},
          "x": {
            "scale": "xscale_average",
            "field": "lifetime"
          },
          "dx": {
            "value": 50
          },
          "y": {
            "value": -35
          },
          "fill": {
            "value": "rgb(70, 53, 52)"
          }
        }
      }
    }
  ],
  "legends": [
    {
      "fill": "color",
      "title": null,
      "orient": "top-left",
      "direction": "vertical",
      "labelColor": "#333",
      "encode": {
        "labels": {
            "update": {}          
          }
      }
    },
    {
      "size": "radius",
      "title": null,
      "titleLimit": 1000,
      "orient": "top-right",
      "direction": "horizontal",
      
      "encode": {
          "labels": {
            "update": {
              "text": {}
            }          
          }
      }
    }
  ]
};